export const persons = [
  { value: 1, label: 'Duc NT' },
  { value: 2, label: 'TrungT' },
  { value: 3, label: 'Thien' },
  { value: 4, label: 'AN' }
];
export const CFName = {
  NcCustomers: 'N&C Customers',
  CollectionJobs: 'Collection Jobs'
}
export const CFType = {
  AtRisksODRs : 8188,
  SupplierDeliveryChanges : 8189,
  AgedODRs : 8190,
  NewODRs : 8191,
  NewCCFs : 8192,
  NcCustomers : 8193,
  MissingInfoCcfs : 8194,
  DDCTrade : 8208,
  DDCCommercial : 8209,
  CcfCriticalReturn : 8263,
  CollectionJobs : 8455,
}

export const departments = [
  { value: 1, label: 'PRODUCTION' },
  { value: 2, label: 'QA' },
  { value: 3, label: 'BA' },
  { value: 4, label: 'Driver' }
];
export const progresses = [
  { value: 1, label: 'To Do' },
  { value: 2, label: 'Inprogress' },
  { value: 3, label: 'Completed' }
];

export const inputPopulateType = [
  { value: 1, label: 'Auto Populate' },
  { value: 2, label: 'Manual Enter' },
  { value: 3, label: 'Formula' }
];

export const trainingUnits = [
  { value: 0, label: 'Day' },
  { value: 1, label: 'Week' },
  { value: 2, label: 'Month' },
];


export const valueCompareType = [
  { value: 0, label: 'Value > Target' },
  { value: 1, label: 'Value < Target' },
];

export const priorites = [
  {
    value: 1,
    falconValue: 100,
    color: 'rgb(230, 55, 87)',
    label: 'P1 - Critical',
    imageUrl: 'https://emplas.atlassian.net/images/icons/priorities/highest.svg'
  },
  {
    value: 2,
    falconValue: 200,
    color: 'rgb(246, 143, 87)',
    label: 'P2 - High',
    imageUrl: 'https://emplas.atlassian.net/images/icons/priorities/high.svg'
  },
  {
    value: 3,
    falconValue: 300,
    color: 'rgb(42, 123, 228)',
    label: 'P3 - Normal',
    imageUrl: 'https://emplas.atlassian.net/images/icons/priorities/medium.svg'
  },
  {
    value: 4,
    falconValue: 500,
    color: '#00D27B',
    label: 'P4 - Medium',
    imageUrl: 'https://emplas.atlassian.net/images/icons/priorities/low.svg'
  },
  {
    value: 5,
    falconValue: 400,
    color: '#D3D3D3',
    label: 'P5 - Low',
    imageUrl: 'https://emplas.atlassian.net/images/icons/priorities/lowest.svg'
  }
];
